import clsx from 'clsx';
import styles from './tooltip.module.css';
import { Typography } from '../typography/typography.component';

export type TooltipProps = {
    content: React.ReactNode;
    className?: string;
    children?: React.ReactNode;
    distance?: number;
    position?: 'top' | 'bottom' | 'left' | 'right';
    textAlign?: 'left' | 'center' | 'right';
};

export const Tooltip = ({
    content,
    className,
    children,
    distance = 15,
    position = 'bottom',
    textAlign = 'center',
}: TooltipProps) => {
    if (!content) {
        return <div className={clsx(styles.root, className)}>{children}</div>;
    }

    return (
        <div className={clsx(styles.root, className)}>
            {children}
            <Typography
                as="span"
                className={clsx(styles.text, {
                    [styles[position]]: position,
                    [styles[`text-${textAlign}`]]: textAlign,
                })}
                style={{ '--tooltip-distance': `${distance}px` } as React.CSSProperties}
            >
                {content}
            </Typography>
        </div>
    );
};
